export default __webpack_public_path__ + "static/media/iconmonstr-refresh-3.a199f920.svg";